<template>
  <div
    class="comment-outer-container"
    :class="{
      'is-pinned': isPinned,
      'for-discussion-page': forDiscussionPage,
    }"
  >
    <div class="comment-inner-container">
      <div
        v-if="commentLink && commentLink.id"
        class="d-flex justify-content-center align-items-center py-3"
      >
        <i>You're viewing a single thread.</i>
        <button
          class="btn see-all ml-2"
          type="button"
          @click="onClickClear"
        >
          See All {{ `${commentTypeTitle}s` }}
        </Button>
      </div>
      <PDPCommentNode
        :discussion="comment"
        :comment="comment"
        :position-indices="positionIndices"
        :comment-type-title="commentTypeTitle"
        :deal-partner-user-ids="dealPartnerUserIds"
        :force-show-all="forceShowAll"
        :filter-comments="filterComments"
        :is-pinned="isPinned"
        :show-all-children="showAllChildren"
        :user="user"
        :for-reviews="forReviews"
        @update-action="updateAction"
        @reply-comment="replyComment"
      />
    </div>
  </div>
</template>

<script>
import throttle from 'lodash/throttle';
import PDPCommentNode from './PDPCommentNode.vue';

export default {
  name: 'PDPComment',
  components: {
    PDPCommentNode,
  },
  inject: {
    forDiscussionPage: {
      default: false,
    },
  },
  props: {
    filterComments: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: Object,
      default: () => ({}),
    },
    commentLink: {
      type: Object,
      default: () => ({}),
    },
    commentTypeTitle: {
      type: String,
      required: true,
    },
    dealPartnerUserIds: {
      type: Array,
      required: true,
    },
    isPinned: {
      type: Boolean,
    },
    positionIndices: {
      type: Array,
      default: () => ([]),
    },
    forceShowAll: {
      type: Boolean,
    },
    showAllChildren: {
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    updateState: {
      type: Object,
      default: () => ({}),
    },
    forReviews: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      hideReplies: false,
    };
  },
  methods: {
    updateAction: throttle(function handler(data) {
      this.$emit('update-action', data);
    }, 200),
    replyComment(data) {
      this.$emit('reply-comment', data);
    },
    onClickClear() {
      this.$emit('on-click-clear');
    },
  },
};
</script>

<style lang="scss" scoped>
  .comment-outer-container.is-pinned {
    padding: 0;
  }

  .comment-inner-container {
    box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    font-size: 1rem;
    width: 100%;
  }

  /* stylelint-disable selector-no-qualifying-type */
  button.see-all {
    min-width: 100px;
    padding: 0.4rem 1.2rem;
    font-size: 12px;
    transition: all 200ms ease-in-out;
    border: 1px solid #272727;
    background-color: #fff;
    color: #272727;
    background-image: none;
  }

  button.see-all:hover {
    border: 1px solid #272727;
    background-color: #272727;
    color: #fff;
  }
  /* stylelint-enable selector-no-qualifying-type */

  // all of this CSS is meant to override the styling for discussion pages
  // to keep this clean I am going to suppress linting rules for the following, since we need
  // ~ this to be nested and centralized to be effective.

  /* stylelint-disable selector-max-compound-selectors, max-nesting-depth */
  .comment-outer-container.for-discussion-page {
    .comment-inner-container {
      box-shadow: none;
      border-radius: unset;
      background-color: unset;

      ::v-deep {

        // this selector targets a couple of elements within the root "discussion"
        .discussion-main-body {

          // space the status container medium distance from the body.
          .status-container.show-status {
            margin-bottom: 1.5rem;

            // since the status tags are not attached to a card on the discussion page we need to
            // ~ round all four corners, not just the top.
            .comment-status-tag {
              border-radius: 3px;
            }
          }

          // space the moderation message for the main item a medium distance.
          .comment-mod-message {
            display: block;
            margin-bottom: 1.5rem;
          }
        }

        .comment-children-outer-container {
          border: unset;
          background: unset;
        }
      }
    }
  }

  /* stylelint-enable selector-max-compound-selectors, max-nesting-depth */
</style>
